import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import Card from '../ui/Card';
import ToolConfigurator from './ToolConfigurator';

/**
 * AgentFormStep3 - Tools Configuration
 */
const AgentFormStep3 = ({ formData, onChange }) => {
  const handleToolsChange = (newTools) => {
    onChange({ target: { name: 'tools', value: newTools } });
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h3 className="text-xl font-semibold text-gray-900 dark:text-spooky-ghost-white mb-2">
          Configure Tools
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Tools allow your agent to perform actions beyond text generation. Add tools to extend your agent's capabilities.
        </p>
      </div>

      {/* Info Card */}
      <Card padding="comfortable" className="bg-blue-50 dark:bg-blue-900/10 border-2 border-blue-200 dark:border-blue-800">
        <div className="flex items-start gap-3">
          <FaInfoCircle className="text-blue-500 text-xl mt-1 flex-shrink-0" />
          <div>
            <h4 className="font-semibold text-gray-900 dark:text-spooky-ghost-white mb-2">
              What are Tools?
            </h4>
            <p className="text-sm text-gray-700 dark:text-gray-300 mb-2">
              Tools are functions that your agent can call to perform specific tasks:
            </p>
            <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-1">
              <li>• <strong>Web Search:</strong> Retrieve real-time information from the internet</li>
              <li>• <strong>Calculator:</strong> Perform complex mathematical calculations</li>
              <li>• <strong>File Reader:</strong> Read and analyze files</li>
              <li>• <strong>API Calls:</strong> Interact with external services</li>
            </ul>
          </div>
        </div>
      </Card>

      {/* Tool Configurator */}
      <div>
        <h4 className="text-sm font-semibold mb-3 text-gray-900 dark:text-spooky-ghost-white">
          Agent Tools {formData.tools?.length > 0 && `(${formData.tools.length})`}
        </h4>
        <ToolConfigurator
          tools={formData.tools || []}
          onChange={handleToolsChange}
        />
      </div>

      {/* Optional Note */}
      <Card padding="default" className="bg-gray-50 dark:bg-spooky-bg-light">
        <p className="text-sm text-gray-600 dark:text-gray-400">
          <strong>Note:</strong> Tools are optional. If your agent doesn't need external functions, you can skip this step and continue to the next one.
        </p>
      </Card>
    </div>
  );
};

export default AgentFormStep3;
